import {
    GET_POYNT_SETTINGS_STARTED,
    GET_POYNT_SETTINGS_SUCCESS,
    GET_POYNT_SETTINGS_FAILURE,
    CREATE_POYNT_SALE_STARTED,
    CREATE_POYNT_SALE_SUCCESS,
    CREATE_POYNT_SALE_FAILURE,
    CANCEL_POYNT_SALE_STARTED,
    CANCEL_POYNT_SALE_SUCCESS,
    CANCEL_POYNT_SALE_FAILURE,
    SET_DEFAULT_DEVICE_POYNT_STARTED,
    SET_DEFAULT_DEVICE_POYNT_SUCCESS,
    SET_DEFAULT_DEVICE_POYNT_FAILURE,
    DISCONNECT_POYNT_STARTED,
    DISCONNECT_POYNT_SUCCESS,
    DISCONNECT_POYNT_FAILURE,

    REMOVE_ERROR_MESSAGE
} from '../../constants/poynt/poynt'

const initialState = {
    poyntSettings: null,
    status: '', // CANCELED or RECEIVED or STARTED or PROCESSED, status returned from poynt callback
    terminals: [],
    loadingTerminals: false,
    loading: false,
    message: null,
    error: null
};

export default function poyntSettings(state = initialState, action) {
    switch (action.type) {
        case DISCONNECT_POYNT_STARTED: {
            return {
                ...state,
                loading: true,
                error: null,
                message: null
            };
        }
        case DISCONNECT_POYNT_SUCCESS: {
            const availableConnections = localStorage.getItem('availableConnections') ? JSON.parse(localStorage.getItem('availableConnections')) : [];
            const defaultPaymentConnection = localStorage.getItem('defaultPaymentConnection') || '';
            if (defaultPaymentConnection === 'poynt-local') {
                localStorage.removeItem('defaultPaymentConnection');
            }
            if (availableConnections.includes('poynt')) {
                availableConnections.splice(availableConnections.indexOf('poynt'), 1);
                localStorage.setItem('availableConnections', JSON.stringify(availableConnections));
            }
            return {
                ...state,
                loading: false,
                poyntSettings: null,
                terminals: [],
                error: null,
            };
        }
        case DISCONNECT_POYNT_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                message: null
            };
        }
        case GET_POYNT_SETTINGS_STARTED: {
            return {
                ...state,
                loading: true,
                error: null,
                message: null
            };
        }

        case GET_POYNT_SETTINGS_SUCCESS: {
            return {
                ...state,
                loading: false,
                poyntSettings: action.payload.poyntSettings,
                terminals: action.payload.terminals,
                error: null,
            };
        }
        case GET_POYNT_SETTINGS_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                message: null
            };
        }

        case CREATE_POYNT_SALE_STARTED: {
            return {
                ...state,
                loadingTerminals: true,
                error: null,
                message: null
            };
        }

        case CREATE_POYNT_SALE_SUCCESS: {
            return {
                ...state,
                loadingTerminals: false,
                error: null,
            };
        }

        case CREATE_POYNT_SALE_FAILURE: {
            return {
                ...state,
                loadingTerminals: false,
                error: action.payload.error,
                message: null
            };
        }

        case CANCEL_POYNT_SALE_STARTED: {
            return {
                ...state,
                loadingTerminals: true,
                error: null,
                message: null
            };
        }

        case CANCEL_POYNT_SALE_SUCCESS: {
            return {
                ...state,
                error: null,
            };
        }

        case CANCEL_POYNT_SALE_FAILURE: {
            return {
                ...state,
                loadingTerminals: false,
                error: action.payload.error,
                message: null
            };
        }

        case SET_DEFAULT_DEVICE_POYNT_STARTED: {
            return {
                ...state,
                loading: true,
                error: null,
                message: null
            };
        }
        case SET_DEFAULT_DEVICE_POYNT_SUCCESS: {
            return {
                ...state,
                loading: false,
                message: "Default device set successfully",
                poyntSettings: {
                    ...state.poyntSettings,
                    defaultDevice: action.payload.defaultDevice
                },
                error: null
            };
        }
        case SET_DEFAULT_DEVICE_POYNT_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                message: null
            };
        }

        case REMOVE_ERROR_MESSAGE: {
            return {
                ...state,
                loading: false,
                error: null,
                message: null
            };
        }

        default:
            return {
                ...state
            };
    }
}
